<ng-container *transloco="let _t">

<div class="header-suppl row">
  <h5 class="col-3 text-end">{{ _t('rm-main-h5-0') }} </h5>
  <div class="col-5">
	<mat-chip-list>
		<mat-chip *ngFor="let slice of sliceFilter"
			color="disabled"
			[ngStyle]="{'background-color': slice.show ? slice.color : '#a6a6a6'}"
			[matBadge]="slice.count" matBadgePosition="after" matBadgeColor="primary"
			[title]="slice.count+' objectifs '+(slice.labl=='Hors audit' ? '':'pour les indicateurs ')+slice.label+'. Cliquez pour '
			+(slice.show ? 'les masquer' : 'les montrer')" 
			(click)="slice.show = !slice.show; calcInit()">
			{{ _t(slice.label) }}
		</mat-chip>
	</mat-chip-list>
  </div>

  <div class="col-4">
	<mat-select aria-label="Trier par" [(ngModel)]="objectifOrder"
		(change)="calcInit()">
	  <mat-option value="slice">{{ _t('rm-main-sort-1') }}</mat-option>
	  <mat-option value="date">{{ _t('rm-main-sort-2') }}</mat-option>
	  <mat-option value="budget">{{ _t('rm-main-sort-3') }}</mat-option>
	</mat-select>
  </div>
</div>

<div class="row">
	<h3 class="col-4">{{ _t('rm-main-h3-0') }}</h3>
	<div class="searchFilter col-8">
		<input type="text" [(ngModel)]="searchFilter"
		[placeholder]="_t('rm-main-placeholder-0')" 
		(keydown)="checkSearchFilter($event)" />
		<button mat-icon-button color="special" (click)="checkSearchFilter()">
			<mat-icon>search</mat-icon></button>
	</div>
	<div class="col-6">
		<p>{{ _t('rm-main-p-0', {nb: gd.selectedBuildingsList.length}) }} :</p>
		<ul>
		<li>{{ _t('rm-main-li-1')}} : 
			<strong>{{objectifs.length}}</strong>
		</li>
		<li>{{ _t('rm-main-li-2')}} : 
			<strong>{{filteredObjectifs.length}}</strong>
		</li>
		<li>{{ _t('rm-main-li-3')}} :
			<strong>{{totalBudgets}} €</strong>
		</li>
		</ul>
	</div>
</div>

<rm-objectif-resume *ngFor="let objectif of filteredObjectifs"
	[objectif]="objectif"
	(onOpen)="displayObjectifSheet(objectif)">
</rm-objectif-resume>




</ng-container>